module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.company.name.caption) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.otherAttribs.length > 0),
      expression: "this.otherAttribs.length > 0"
    }],
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("face")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.getOtherAttribsNameShort()))])])], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(60, 104)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-company-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "company": _vm.company,
      "notesAvailable": _vm.company && _vm.company.inn && _vm.getProfileHaveClient && _vm.favoriteLists != null,
      "notesEditable": !_vm.accountNameShort,
      "privateNotes": _vm.privateNotes,
      "notes": _vm.notes,
      "tags": _vm.tags,
      "monitoring": _vm.monitoring,
      "otherAttribs": _vm.otherAttribs,
      "clientCompanyId": _vm.clientCompanyId,
      "banks": _vm.banks
    },
    on: {
      "refresh": function($event) {
        return _vm.refreshCompanyProps()
      }
    }
  })], 1), _vm._v(" "), (_vm.refCode && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-contacts-panel', {
    attrs: {
      "fill-height": "",
      "refCode": _vm.refCode
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.refCode && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-banks-panel', {
    attrs: {
      "fill-height": "",
      "banks": _vm.banks
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company && !(_vm.company.status && _vm.company.status.kind === 'GOOD')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-reorg-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-assignees-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-branches-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-activities-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "activities": _vm.company.activities
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-licenses-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-trademarks-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-holders-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn,
      "capital": _vm.company.capital,
      "holderRegister": _vm.company.holderRegister
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-children-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-manageds-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-fin-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-tax-pay-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "model": {
        ogrn: _vm.company.ogrn,
        staffNumber: _vm.company.staffNumber,
        taxOffence: _vm.company.taxOffence ? _vm.company.taxOffence.value : null
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-arrears-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-enforcement-debts-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn),
      expression: "company && company.inn"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-enforcements-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn),
      expression: "company && company.inn"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-records-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "records": _vm.company.records
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-credentinals-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && (_vm.company.tax || _vm.company.pf || _vm.company.fss || _vm.company.registration)),
      expression: "company && (company.tax || company.pf || company.fss || company.registration)"
    }],
    attrs: {
      "fill-height": "",
      "reg": _vm.company.registration,
      "tax": _vm.company.tax,
      "pf": _vm.company.pf,
      "fss": _vm.company.fss
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-history-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn,
      "clientId": _vm.company.clientId
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-links-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn),
      expression: "company && company.inn"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn,
      "clientId": _vm.company.clientId
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.company && _vm.company.inn) ? _c('v-client-preview-panel', {
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.company && _vm.company.reference && _vm.company.reference.ref && _vm.getProfileHaveClient) ? _c('v-visit-panel', {
    attrs: {
      "fill-height": "",
      "topCount": 5,
      "refCode": _vm.company.reference.ref
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode !== 'mainPage'),
      expression: "mode !== 'mainPage'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn && !_vm.company.clientId && !this.accountNameShort),
      expression: "company && company.inn && !company.clientId && !this.accountNameShort"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Приглашение', 'mail_outline', 'Пригласить в Систему АТЛАНТ-СМАРТ', _vm.invite), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', _vm.copyLink), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn && _vm.getProfileHaveClient && !_vm.favoriteLists && !this.accountNameShort),
      expression: "company && company.inn && getProfileHaveClient && !favoriteLists && !this.accountNameShort"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', _vm.addFavorite), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn && _vm.getProfileHaveClient && _vm.favoriteLists && !this.accountNameShort),
      expression: "company && company.inn && getProfileHaveClient && favoriteLists && !this.accountNameShort"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', _vm.dialogOpenFavorite), {
    tag: "v-component"
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a280d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/ClientPage.vue
// module id = 1096
// module chunks = 1